<template lang="html">
  <div class="stitched-outfits-container">
    <RemoveOutfitModal />
    <LoadingProducts v-if="!outfitsLoaded" />

    <div v-else>
      <!-- <LayoutToggle @toggleLayout="toggleLayout" /> -->
      <BoxLayoutList :outfits="wardrobeOutfits" />

      <!-- <div v-for="outfit in wardrobeOutfits" :key="outfit.id">
        <b-row align-h="between" class="title-row">
          <b-col cols="6">
            <span class="title-row--title">{{ outfit.title }} ∙ </span>
            <span class="title-row--date">{{ formatDate(outfit.created_at) }}</span>

          </b-col>
          <b-col cols="6">
            <a
              class="destroy-outfit-btn float-right"
              @click.prevent="destroyOutfit(outfit.id)"
            >
              <i class="action-icon pe-7s-trash"></i>
            </a>
          </b-col>
        </b-row>


        <div
          :class="`${layoutName}-layout flex-${colCount(outfit.products)}-cols`"
          class="outfit-container mb-5"
        >
          <div
            class="grid-item"
            v-for="product in sortProductBySequence(outfit.products)"
            :key="product.id"
          >
            <div class="layer-content-wrapper">
              <div class="layer-image-wrapper">
                <b-img
                  :src="product.featured_image"
                  class="img-fluid w-100 d-block layer-image"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="astrodivider">
          <div class="astrodividermask"></div>
          <span><i class="fi flaticon-034-button"></i></span>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import LoadingProducts from "@/components/wardrobe/LoadingProducts";
import LayoutToggle from "@/components/wardrobe/outfits/LayoutToggle";
import BoxLayoutList from "@/components/wardrobe/outfits/BoxLayoutList";
import RemoveOutfitModal from "@/components/wardrobe/outfits/RemoveOutfitModal";
import CapsuleUtils from "@/utils/CapsuleUtils";
import { mapActions, mapGetters } from "vuex";

export default {
  created() {
    this.formatDate = CapsuleUtils.formatDate;
  },

  mounted() {
    window.analytics.page("Wardrobe Outfits");

    if (!this.wardrobeDataStates.outfits.fetching && !this.outfitsLoaded) {
      this.fetchWardrobeOutfits(this.currentUser.wardrobe_id).then(() => {
        if (
          !this.wardrobeDataStates.products.fetching &&
          !this.wardrobeDataStates.products.loaded
        )
          this.fetchWardrobeProducts(this.currentUser.wardrobe_id);
      });
    }
  },

  data() {
    return {
      gridLayout: false,
    };
  },

  components: {
    LoadingProducts,
    LayoutToggle,
    BoxLayoutList,
    RemoveOutfitModal,
  },

  computed: {
    ...mapGetters(["currentUser", "wardrobeOutfits", "wardrobeDataStates"]),

    // layoutName() {
    //   return this.gridLayout ? "grid" : "line";
    // },

    outfitsLoaded() {
      return this.wardrobeDataStates.outfits.loaded;
    },
  },

  methods: {
    ...mapActions(["fetchWardrobeOutfits", "fetchWardrobeProducts"]),

    // toggleLayout(layoutName) {
    //   this.gridLayout = layoutName === "grid";
    // },

    // sortProductBySequence(products) {
    //   return [...products].sort((a, b) => a.sequence - b.sequence);
    // },

    // colCount(products) {
    //   return !this.gridLayout ? "7" : products.length < 7 ? "3" : "4";
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";
@import "~@/styles/_grid_breakpoints.scss";

// @mixin flex-grid($cols, $gutter: 0, $max-cols: 4) {
//   display: flex;
//   flex-wrap: wrap;

//   > * {
//     // Reset to prevent external styles break the grid.
//     margin-left: 0;
//     margin-bottom: 0;
//     $item-width: calc((100% / #{$cols}) - #{$gutter} + (#{$gutter} / #{$cols}));
//     $item-max-width: calc(
//       (100% / #{$max-cols}) - #{$gutter} + (#{$gutter} / #{$cols})
//     );
//     margin-right: $gutter;
//     width: $item-width;
//     max-width: $item-max-width;
//     box-sizing: border-box;

//     // We add the gutter for all items except the first row.
//     &:nth-child(n + #{$cols + 1}) {
//       margin-top: $gutter;
//     }

//     // When we reach the cols per line, the last
//     // col item must not have margin right.
//     &:nth-child(#{$cols}n) {
//       margin-right: 0;
//     }
//   }
// }

// .flex-2-cols {
//   @include flex-grid(2, 40px);
// }

// .flex-3-cols {
//   @include flex-grid(3, 5px);

//   @include for-tablet-portrait-up {
//     @include flex-grid(3, 30px);
//   }
// }

// .flex-4-cols {
//   @include flex-grid(4, 5px);

//   @include for-tablet-portrait-up {
//     @include flex-grid(4, 20px);
//   }
// }

// .flex-5-cols {
//   @include flex-grid(5, 20px);
// }

// .flex-7-cols {
//   @include flex-grid(7, 5px, 7);

//   @include for-tablet-portrait-up {
//     @include flex-grid(7, 10px, 7);
//   }
// }

// .flex-9-cols {
//   @include flex-grid(9, 20px);
// }

// .outfit-row {
//   margin-bottom: 75px;

//   .outfit-title {
//     font-size: 20px;
//     line-height: 32px;
//     color: $grey1;
//   }
// }

.stitched-outfits-container {
  margin-top: 80px;
}

// .outfit-container {
//   background: transparent;
//   border-radius: 10px;
//   color: #fff;
//   font-size: 21px;
//   font-weight: normal;
//   justify-content: center;
//   line-height: 1.3em;
//   margin: 10px;
//   padding: 20px;
//   text-shadow: -1px -1px #aa3030;

//   @include for-tablet-portrait-up {
//     padding: 15px;
//   }

//   .grid-item {
//     .layer-content-wrapper {
//       background: white;
//       border-radius: 0.3em !important;
//       border: 1px solid $grey5;
//       box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
//       height: 100%;
//       padding: 5px;
//       text-align: center;

//       @include for-tablet-portrait-up {
//         padding: 10px;
//       }
//     }
//   }
// }

// .astrodivider {
//   margin: 128px auto;
//   width: 400px;
//   max-width: 100%;
//   position: relative;
// }

// .astrodividermask {
//   overflow: hidden;
//   height: 20px;
// }

// .astrodividermask:after {
//   content: "";
//   display: block;
//   margin: -25px auto 0;
//   width: 100%;
//   height: 25px;
//   border-radius: 125px / 12px;
//   box-shadow: 0 0 8px $primary-accent-darker;
// }

// .astrodivider span {
//   width: 66px;
//   height: 48px;
//   position: absolute;
//   bottom: 100%;
//   margin-bottom: -25px;
//   left: 50%;
//   margin-left: -25px;
//   border-radius: 100%;
//   background: transparent;
// }

// .astrodivider i {
//   position: absolute;
//   top: 4px;
//   bottom: 4px;
//   left: 4px;
//   right: 4px;
//   border-radius: 100%;
//   text-align: center;
//   line-height: 40px;
//   font-style: normal;
//   font-size: 36px;
//   color: $primary-accent-darker;
//   background: #fff;
// }

// .destroy-outfit-btn {
//   padding: 5px 10px;
//   font-size: 1.5rem;
// }

// .title-row {
//   align-items: center;

//   .title-row--title {
//     font-size: 1.2rem;
//     font-weight: 500;
//     color: grey1;
//   }

//   .title-row--date {
//     font-size: 0.9rem;
//     color: grey2;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/pages/Users/Wardrobe/WardrobeOutfits.vue